import React, { useEffect } from 'react';

import { useMenuTitle } from 'hooks/useMenuTitleContext';
import AdvisorsMarketplace from 'microfrontends/Marketplace/Advisors';
import GeneralMarketplace from 'microfrontends/Marketplace/General';
import ServicesMarketplace from 'microfrontends/Marketplace/Services';

interface SolutionsMarketplaceProps {
  type: 'advisor' | 'courses' | 'services' | 'plans';
  title: string;
  categoryId?: number;
}

const SolutionsMarketplace: React.FC<SolutionsMarketplaceProps> = ({ type, title, categoryId }) => {
  const { updateMenuTitle } = useMenuTitle();

  useEffect(() => {
    updateMenuTitle(title);
  }, [title, updateMenuTitle]);

  switch (type) {
    case 'advisor':
      return <AdvisorsMarketplace />;
    case 'services':
      return <ServicesMarketplace />;
    case 'courses':
    case 'plans':
      if (!categoryId) {
        console.error(`[SolutionsMarketplace] categoryId é obrigatório para o tipo ${type}`);
        return null;
      }
      return <GeneralMarketplace categoryId={categoryId} />;
    default:
      return null;
  }
};

export default SolutionsMarketplace;
